import type { IConfigInterface } from "./IConfigInterface";

export const ConfigTest: IConfigInterface = {
    ApiUrl: "https://ApiUrl.com",
    UseServiceWorker: false,
    CacheAssets: true,
    ConnectedUser: null,
    Environment: "Test",
    // Ferme / expédié
    CommandeReadOnlyStatus: "1fb523c2-cd18-47e0-8939-7f4099f3a7ed.31c207c8-2a4b-4110-ba2e-219d76d550ee",
};
